import axios from "axios";
import React, { useState, useCallback } from "react";
import { Button, Modal } from 'react-bootstrap';
import { NotificationManager } from "react-notifications";
import { useNavigate } from "react-router-dom";

export default function AddExperience({ idCv }) {
    const [show, setShow] = useState(false);
    const [experience, setExperience] = useState({
        entreprise: '',
        debutDate: '2023',
        finDate: '2024',
        descrExp: ''
    });
    const navigate = useNavigate();

    const years = Array.from({ length: 51 }, (_, i) => 1990 + i);

    // Centralisation de la gestion des changements
    const handleChange = (e) => {
        const { name, value } = e.target;
        setExperience(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    // Validation basique
    const validateForm = () => {
        return experience.entreprise && experience.debutDate && experience.finDate && experience.descrExp;
    };

    // Enregistrement de l'expérience
    const handleExp = useCallback(async () => {
        if (!validateForm()) {
            NotificationManager.warning('Veuillez remplir tous les champs', 'Erreur', 4000);
            return;
        }

        const dataExp = new FormData();
        dataExp.append('societe', experience.entreprise);
        dataExp.append('datexp', experience.debutDate);
        dataExp.append('datefin', experience.finDate);
        dataExp.append('descriptionexp', experience.descrExp);
        dataExp.append('cv_id', idCv);

        try {
            const resp = await axios.post('experiences', dataExp);
            if (resp.status === 201) {
                NotificationManager.success('Expérience enregistrée avec succès', 'Succès', 4000);
                // navigate(`/editCv/${idCv}`);
                window.location.reload();
            } else {
                NotificationManager.warning('Une erreur est survenue', 'Erreur', 4000);
            }
        } catch (error) {
            NotificationManager.error("Une erreur est survenue lors de l'enregistrement", 'Erreur', 4000);
            console.error(error);
        }
    }, [experience, idCv, navigate]);

    return (
        <>
            <Button variant="info" onClick={() => setShow(true)}>
                <b>+</b> Ajouter une expérience
            </Button>

            <Modal show={show} onHide={() => setShow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Ajouter une expérience</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form>
                        <div className="form-group">
                            <label htmlFor="entreprise" className="form-label">Nom de l'entreprise</label>
                            <input
                                id="entreprise"
                                name="entreprise"
                                required
                                value={experience.entreprise}
                                onChange={handleChange}
                                maxLength={50}
                                className="form-control mb-2"
                                type="text"
                                placeholder="Société"
                            />
                        </div>

                        <div className="form-group">
                            <label className="form-label">Date de début et de fin</label>
                            <div className="input-group">
                                <select
                                    name="debutDate"
                                    value={experience.debutDate}
                                    onChange={handleChange}
                                    className="form-control"
                                >
                                    {years.map((year) => (
                                        <option value={year} key={year}>{year}</option>
                                    ))}
                                </select>
                                <select
                                    name="finDate"
                                    value={experience.finDate}
                                    onChange={handleChange}
                                    className="form-control"
                                >
                                    {years.map((year) => (
                                        <option value={year} key={year}>{year}</option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="descrExp" className="form-label">Description du poste</label>
                            <textarea
                                id="descrExp"
                                name="descrExp"
                                required
                                value={experience.descrExp}
                                onChange={handleChange}
                                className="form-control mb-2"
                                placeholder="Description de votre poste"
                                rows="3"
                            />
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="success" onClick={handleExp}>
                        Enregistrer
                    </Button>
                    <Button variant="secondary" onClick={() => setShow(false)}>
                        Fermer
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
